import type { SWRResponse } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { CompanyBase } from 'models';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { CompanyProfileService } from 'services/CompanyProfileService';

import { prepareConditionalSwrArgs } from './prepare-conditional-swr-args';

export type CompanyTeamMember = {
    name: string;
    email?: string;
    image?: string;
    position?: string;
};

export const useCompanyTeamMembers = (
    company?: CompanyBase | CompanyBase['id'] | null,
): { members: CompanyTeamMember[] } & SWRResponse<CompanyTeamMember[]> => {
    const companyId = CollectionHelpers.id(company);

    const swr = useSWRImmutable<CompanyTeamMember[]>(
        ...prepareConditionalSwrArgs({
            key: companyId ? `/api/manufacturers/${companyId}/team-members` : '',
            fetcher: () => CompanyProfileService.getTeamMembers(companyId!),
            condition: Boolean(companyId),
        }),
    );

    return {
        ...swr,
        members: swr?.data ?? [],
    };
};
